import '.l{width:100%;}.ssr-plugin'
import '.bc{padding-inline:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.b8{position:sticky;}.ssr-plugin'
import '.b9{top:0px;}.ssr-plugin'
import '.bd{z-index:10;}.ssr-plugin'
import '.bb{background:var(--nav-bg);}.ssr-plugin'
import { type ReactNode } from 'react'
import { Style, styled } from 'inlines'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

export type NavBarDesktopProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  logo: ReactNode
  children: ReactNode
  style?: Style
}

export const NavBarDesktop = ({
  logo,
  children,
  style,
}: NavBarDesktopProps) => {
  const transformStyle = useTransform('center')

  return (
    <styled.nav className="l bc d ai b8 b9 bd bb"
      style={{
        ...style,
      }}
    >
      <ResponsiveContainer
        style={{
          background: 'var(--nav-bg)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          textStyle={{ lineHeight: 0 }}
        >
          {logo}
        </TextLink>
        {children}
      </ResponsiveContainer>
    </styled.nav>
  )
}
